import { apiRegulationQuery, apiRegulationSearchNotebook, apiGenAIChatCompletion, apiSaveToNotebook } from "../../utils/api";
import { convertMarkdownToHTML, convertMarkdownToHTML_2, getParamUrl } from "../../utils/utils";

const $ = window.jQuery;
const MAX_STEP_API = 5;
const MAX_COUNT_API = 3;
let countApi = 0, stepApi = 0;
const TYPE_MESS = {
  LOADING: "analyzing",
  USER: "user-message",
  AI: "ai-message"
}

export function setUpChat(isShowAlways = false) {
  apiRegulationSearchNotebook({ ...getParamUrl() }, function (data) {
    if (0 < data.length) {
      $("#myChatBox").attr("data-notebook-id", data[0].notebook_id);

      if (isShowAlways) {
        $(".chat-toggle").hide();
        $("#myChatBox").addClass("always");
      }
      $(".chat-toggle").on("click", function () {
        $("#myChatBox").toggleClass("active");
      });
    
      $(".chat-controls #btnClose").on("click", function () {
        $("#myChatBox").toggleClass("active");
      });
    } else {
      $('.regulationQuery').hide();
    }
  });

  $(".chat-box .query-button .btn").on("click", function () {
    let inputQuery = $('.chat-box .message-input');
    let step = inputQuery.attr("step") * 1;
    if (inputQuery.val()) {
      addMessage(TYPE_MESS.USER, inputQuery.val().trim());
      setTimeout(() => {
        $('.chat-box .form-answer .message-group').scrollTop($('.chat-box .form-answer .message-group').prop('scrollHeight'));
      }, 500);
      let params = {
        ...window.searchData,
        query: inputQuery.val(),
        step: step,
      };
      let notebookId = $("#myChatBox").data("notebook-id");
      if (notebookId) {
        params.notebook_ids = [notebookId];
      }
      inputQuery.val("");
      document.querySelector('.chat-box .form-question .message-input').style.height = '';
      addMessage(TYPE_MESS.LOADING);
      regulationQueryApi(params);
    }
  });

  $(document).on("click", function (e) {
    // Nếu chatBox đang mở
    if ($("#myChatBox").hasClass("active")) {
      if (
        $(e.target).closest("#myChatBox").length === 0 &&
        $(e.target).closest(".chat-toggle").length === 0
      ) {
        $("#myChatBox").removeClass("active");
      }
    }
  });

  $('.chat-box .message-input').on('keyup', function (e) {
    const keycode = (e.keyCode ? e.keyCode : e.which);
    if (keycode === 13) {
      $(".chat-box .query-button .btn").trigger("click");
    } else {
      $('.chat-box .message-input').attr("step", 1);
    }
  })

  addMessage(TYPE_MESS.AI, "What can I help with?");
}

function regulationQueryApi(params) {
  stepApi = 0;
  apiRegulationQuery(params, /** @param {RegulationQuery} data */ function (data) {
    if (data.answer) {
      // typeWriterAnimtion(data.answer, $(".chat-box .form-answer .message"));
      addMessage(TYPE_MESS.AI, data.answer, { addSaveButton: false });
    } else {
      if (data.status === "completed") {
        addMessage(TYPE_MESS.AI, "Not Found Answer");
      } else {
        if (stepApi < MAX_STEP_API) {
          stepApi++;
          setTimeout(() => {
            params.step += 1;
            $('.chat-box .message-input').attr("step", params.step);
            addMessage(TYPE_MESS.LOADING, data.statusText);
            regulationQueryApi(params);
          }, params.step > 5 ? 6000 : 0);
        } else {
          addMessage(TYPE_MESS.AI, "Not Found Answer");
        }
      }
    }
  },
    function (error) {
      if (countApi < MAX_COUNT_API) {
        countApi++;
        regulationQueryApi(params);
      } else {
        addMessage(TYPE_MESS.AI, "Not Found Answer");
      }
    }
  )
}

function addMessage(type, message, options = {}) {
  $(".chat-box .query-button .btn").prop("disabled", type === TYPE_MESS.LOADING);
  if (type === TYPE_MESS.USER) {
    $(".chat-box .form-answer .message-group .user-message").removeClass("last");
  }
  if (type === TYPE_MESS.AI) {
    $(".chat-box .form-answer .message-group .ai-message").removeClass("last");
  }
  
  switch (type) {
    case TYPE_MESS.LOADING:
      $('.chat-bubble-loading:last-child').fadeOut(500);
      $(".chat-box .form-answer .message-group").append(`
        <div class="message analyzing chat-bubble-loading">
          <div class="chat-bubble">
            <div class="typing">
              <div class="statusText">${message || "Analyzing"}</div>&nbsp;&nbsp;
              <div class="bubble"></div>
              <div class="bubble"></div>
              <div class="bubble"></div>
            </div>
          </div>
        </div>
      `);
      setTimeout(() => {
        $('.chat-box .form-answer .message-group').scrollTop($('.chat-box .form-answer .message-group').prop('scrollHeight'));
      }, 500);
      break;

    default:
      // const processedAnswer = message.replace(/\n/g, '<br>');
      $(".chat-box .form-answer .message-group").append(`
        <div class="message ${type} last">
          ${options.addSaveButton ? `
            <div class="message-header">
              <button class="btn btn-sm btn-primary save-to-notebook" title="Save to notebook">
                Save to notebook
              </button>
            </div>
          ` : ''}
          ${convertMarkdownToHTML(convertMarkdownToHTML_2(message))}
        </div>
      `);

      if (type === TYPE_MESS.AI) {
        $(".chat-box .form-answer .message-group .message.analyzing").remove();
        scrollTopLastMessage();
        $(".chat-box .form-answer .message-group .message.last .save-to-notebook").on("click", function() {
          const notebookId = $("#myChatBox").data("notebook-id");
          showSaveModal(notebookId, message);
        });
      }
      break;
  }
}

function scrollTopLastMessage() {
  const $container = $('.chat-box .form-answer .message-group');
  const $target = $container.find('.user-message.last');

  if ($target?.length) {
    // Vị trí tuyệt đối của target so với document
    const targetOffset = $target.offset().top;
    // Vị trí tuyệt đối của container so với document
    const containerOffset = $container.offset().top;
    // Vị trí thanh cuộn hiện tại của container
    const currentScroll = $container.scrollTop();

    // Tính toạ độ cuộn cần thiết
    const scrollToPos = targetOffset - containerOffset + currentScroll;

    $container.animate({ scrollTop: scrollToPos }, 500);
  }
}

function showSaveModal(notebookId, content) {
  // Create and append modal if it doesn't exist
  if (!$("#saveNotebookModal").length) {
    $("body").append(`
      <div class="modal fade" id="saveNotebookModal" tabindex="-1" aria-labelledby="saveNotebookModalLabel" aria-hidden="true">
        <div class="modal-dialog">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title" id="saveNotebookModalLabel">Save to Notebook</h5>
            </div>
            <div class="modal-body">
              <div class="mb-3">
                <label for="noteTitle" class="form-label">Title</label>
                <textarea type="text" class="form-control" id="noteTitle" placeholder="Enter title"></textarea>
                <button class="btn btn-sm btn-outline-secondary generate-title" type="button" title="Generate title with AI">
                  Generate title with AI
                </button>
              </div>
              <div class="mb-3">
                <label for="noteContent" class="form-label">Content</label>
                <textarea class="form-control" id="noteContent" rows="4"></textarea>
              </div>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-secondary" data-dismiss="modal" aria-label="Close">Cancel</button>
              <button type="button" class="btn btn-primary" id="confirmSave">Save</button>
            </div>
          </div>
        </div>
      </div>
    `);

    // Add event listener for generate title button
    $("#saveNotebookModal .generate-title").on("click", function() {
      const content = $("#noteContent").val();
      generateTitleFromContent(content);
    });

    // Add event listener for save button
    $("#confirmSave").on("click", function() {
      const title = $("#noteTitle").val();
      const content = $("#noteContent").val();
      
      if (!title) {
        alert("Please enter a title");
        return;
      }

      saveToNotebook($("#saveNotebookModal"), {
        notebook_id: notebookId,
        is_original: false,
        string_filter: { "country": ["us"], "source": ["custom"] },
        sources:[
          {
            title: title,
            content: content
          }
        ]
      });
      
      // Hide modal using Bootstrap's modal method
      $("#saveNotebookModal").modal('hide');
    });
  }

  // Set content and show modal
  $("#noteContent").val(content);
  $("#noteTitle").val("").focus();
  
  // Show modal using Bootstrap's modal method
  $("#saveNotebookModal").modal('show');
}

function generateTitleFromContent(content) {
  // Show generating indicator
  $("#titleGenerating").show();
  $("#saveNotebookModal .generate-title").prop('disabled', true);

  // Call your AI API to generate a title
  apiGenAIChatCompletion({
    args: [
      "Act as a creative copywriter. Please generate a single, compelling, and concise title that captures the essence of the following topic in a way that stands out and entices readers\nOutput: Represent output in JSON format\nExample:\n{\"title\": \"\"}",
      content
    ],
  }, function(response) {
    if (response.title) {
      // Clean up the response and set it as the title
      const generatedTitle = response.title
        .replace(/["']/g, '') // Remove quotes
        .replace(/^Title: /i, '') // Remove "Title:" prefix if present
        .trim();
      
      $("#noteTitle").val(generatedTitle);
    } else {
      alert("Failed to generate title. Please try again or enter manually.");
    }
    
    // Hide generating indicator
    $("#titleGenerating").hide();
    $("#saveNotebookModal .generate-title").prop('disabled', false);
  }, function(error) {
    alert("Failed to generate title. Please try again or enter manually.");
    
    // Hide generating indicator
    $("#titleGenerating").hide();
    $("#saveNotebookModal .generate-title").prop('disabled', false);
  });
}

function saveToNotebook(modal, data) {
  // Add your API call here to save to notebook
  apiSaveToNotebook(data, function(response) {
    modal.modal('hide');
  });
}
